import { Badge } from "@/components/ui/badge";
import { STATUS_STYLE } from "@/lib/crm";

export const BrandMark = ({ light }) => (
  <div className="flex items-center gap-3" data-testid="brand-mark">
    <div className="h-10 w-10 rounded-lg bg-[#D4AF37] grid place-items-center font-display font-extrabold text-[#19082B] text-lg">VA</div>
    <div className="leading-tight">
      <div className={`font-display font-extrabold tracking-tight ${light ? "text-white" : "text-[#19082B]"}`}>VA BRAND BUILDER</div>
      <div className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] font-semibold">Powered by AVY</div>
    </div>
  </div>
);

export const StatusBadge = ({ status, label, testId }) => (
  <Badge variant="outline" className={`font-medium whitespace-nowrap ${STATUS_STYLE[status] || ""}`} data-testid={testId}>{label || status}</Badge>
);

export const Avatar = ({ user, size = 36, testId }) => {
  const dim = { width: size, height: size };
  if (user?.picture) return <img src={user.picture} alt={user.name} className="rounded-full object-cover shrink-0 border border-[#D4AF37]/40" style={dim} data-testid={testId} />;
  return <div className="rounded-full bg-[#D4AF37] grid place-items-center font-bold text-[#19082B] shrink-0" style={{ ...dim, fontSize: size * 0.4 }} data-testid={testId}>{(user?.name || "?").trim().slice(0, 1).toUpperCase()}</div>;
};

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between mb-8 fade-up">
    <div className="space-y-2">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#19082B]" data-testid="page-title">{title}</h1>
      {subtitle && <p className="text-sm md:text-base text-stone-600 max-w-2xl">{subtitle}</p>}
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
